<template>
    <div class="recap-table" id="recap-table">
        <div class="header-item">
            <p>Approx. final volume = {{formatNumber(getBagVolumeValue(), 0)}} mL</p>
            <!-- <p>Total volume in bag = {{this.volumes.total}} mL</p>
            <p>Total volume lipid = {{this.volumes.lipid}} mL</p>
            <p>Total volume clear = {{this.volumes.clear}} mL</p> -->
        </div>
        <div class="header-item">
            <p>Total energy in bag = {{formatNumber(getEnergyValue(), 0)}} kcal<span v-if="baseInfo.label === 'Primene'">/L</span></p>
        </div>
        <div class="header-item" v-if="baseInfo.label === 'Primene'">
            <p>Approx. Osmolarity = {{formatNumber(getOsmolarityValue(), 0)}} mOsm/L</p>
        </div>
        <div class="table-extra-header">
            <p v-if="baseInfo.label === 'Primene'">TOTAL CONTENT PER LITRE</p>
            <p v-else>TOTAL CONTENT OF BAG</p>
        </div>
        <div class="formulation-table">
            <table>
                <tr>
                    <th width="50%" class="text-left">Constituent</th>
                    <th width="25%" class="text-right">Quantity</th>
                    <th width="25%">UOM</th>
                </tr>
                <template v-if="formData.bag_volume">

                    <tr v-if="getNitrogenValue()">
                        <td class="text-left">Nitrogen</td>
                        <td class="text-right">{{ formatNumber(getNitrogenValue(), 2) }}</td>
                        <td>g</td>
                    </tr>
                    <tr v-if="getAminoAcidValue()">
                        <td class="text-left">Amino acid</td>
                        <td class="text-right">{{ formatNumber(getAminoAcidValue(), 2) }}</td>
                        <td>g</td>
                    </tr>
                    <tr v-if="getGlucoseValue('g')">
                        <td class="text-left">Glucose</td>
                        <td class="text-right">{{ formatNumber(getGlucoseValue('g'), 2) }}</td>
                        <td>g</td>
                    </tr>
                    <!-- <tr v-if="getGlucoseValue('kcal')">
                        <td class="text-left">Glucose</td>
                        <td class="text-right">{{ formatNumber(getGlucoseValue('kcal'), 2) }}</td>
                        <td>kcal</td>
                    </tr> -->
                    <tr v-if="getLipidValue('g')">
                        <td class="text-left">Lipid</td>
                        <td class="text-right">{{ formatNumber(getLipidValue('g'), 2) }}</td>
                        <td>g</td>
                    </tr>
                    <!-- <tr v-if="getLipidValue('kcal')">
                        <td class="text-left">Lipid</td>
                        <td class="text-right">{{ formatNumber(getLipidValue('kcal'), 2) }}</td>
                        <td>kcal</td>
                    </tr> -->
                    <template v-for="(item, index) in getElectrolitesList()">
                        <template v-if="item.label == 'Phosphate' && baseInfo.label === 'Synthamin + Lipid'">
                            <tr v-if="getElectrolyteValue(item, false)" :key="'el_phosphate_' + index" >
                                <td class="text-left">Phosphate (excl. lipid)</td>
                                <td class="text-right">{{ formatNumber(getElectrolyteValue(item, false), 2) }}</td>
                                <td>mmol</td>
                            </tr>
                        </template>
                        <tr v-if="getElectrolyteValue(item, true)" :key="'el_' + index" >
                            <td class="text-left">{{ getElectrolyteLabel(item) }}</td>
                            <td class="text-right">{{ formatNumber(getElectrolyteValue(item, true), 2) }}</td>
                            <td>mmol</td>
                        </tr>
                    </template>
                    <!-- Chloride / Acetate - triple chambers -->
                    <template v-if="baseInfo.bag_type === 'triple_chamber'">
                        <tr>
                            <td class="text-left">Chloride</td>
                            <td class="text-right">{{ formatNumber(getTripleChamberBagChlorideValue(), 2) }}</td>
                            <td>mmol</td>
                        </tr>
                        <tr>
                            <td class="text-left">Acetate</td>
                            <td class="text-right">{{ formatNumber(baseInfo.default_list_data.acetate, 2) }}</td>
                            <td>mmol</td>
                        </tr>
                    </template>
                    <!-- Chloride / Acetate - custom -->
                    <template v-if="baseInfo.bag_type === 'custom'">
                        <template v-if="formData.formulation.chloride_acetate.label === 'Balanced'">
                            <tr>
                                <td class="text-left">Chloride</td>
                                <td class="text-centre" colspan="2">Balanced</td>
                            </tr>
                            <tr>
                                <td class="text-left">Acetate</td>
                                <td class="text-centre" colspan="2">Balanced</td>
                            </tr>
                        </template>
                        <template v-if="formData.formulation.chloride_acetate.label === 'Maximum Chloride'">
                            <tr>
                                <td class="text-left">Chloride</td>
                                <td class="text-centre" colspan="2">Maximum</td>
                            </tr>
                            <tr>
                                <td class="text-left">Acetate</td>
                                <td class="text-centre" colspan="2">Specified by Baxter</td>
                            </tr>
                        </template>
                        <template v-if="formData.formulation.chloride_acetate.label === 'Maximum Acetate'">
                            <tr>
                                <td class="text-left">Chloride</td>
                                <td class="text-centre" colspan="2">Specified by Baxter</td>
                            </tr>
                            <tr>
                                <td class="text-left">Acetate</td>
                                <td class="text-centre" colspan="2">Maximum</td>
                            </tr>
                        </template>
                        <template v-if="formData.formulation.chloride_acetate.label === 'Specified Chloride' && formData.formulation.chloride_acetate.quantity">
                            <tr>
                                <td class="text-left">Chloride</td>
                                <td class="text-centre" colspan="2">Specified - {{ formatNumber(getCustomBagChlorideAcetateValue(), 2) }} mmol</td>
                            </tr>
                            <tr>
                                <td class="text-left">Acetate</td>
                                <td class="text-centre" colspan="2">Specified by Baxter</td>
                            </tr>
                        </template>
                        <template v-if="formData.formulation.chloride_acetate.label === 'Specified Acetate' && formData.formulation.chloride_acetate.quantity">
                            <tr>
                                <td class="text-left">Chloride</td>
                                <td class="text-centre" colspan="2">Specified by Baxter</td>
                            </tr>
                            <tr>
                                <td class="text-left">Acetate</td>
                                <td class="text-centre" colspan="2">Specified - {{ formatNumber(getCustomBagChlorideAcetateValue(), 2) }} mmol</td>
                            </tr>
                        </template>
                    </template>
                    <template v-for="(item, index) in formData.traceElementRecapTotals">
                        <tr v-if="item.value" :key="'te_' + index" >
                            <td class="text-left">{{ item.name }}</td>
                            <td class="text-right">{{ formatNumber(getTraceElementValue(item.value) , 2) }}</td>
                            <td>
                                <template v-if="formData.micronutrientsUnit === 'microgram'">&micro;g</template>
                                <template v-if="formData.micronutrientsUnit === 'micromol'">&micro;mol</template>
                            </td>
                        </tr>
                    </template>
                    <template v-if="baseInfo.default_list_data.extra_zinc && !zincInTraceElementRecapTotals()">
                        <tr>
                            <td class="text-left">Zinc</td>
                            <td class="text-right">{{ formatNumber(baseInfo.default_list_data.extra_zinc[formData.micronutrientsUnit], 2) }}</td>
                            <td>
                                <template v-if="formData.micronutrientsUnit === 'microgram'">&micro;g</template>
                                <template v-if="formData.micronutrientsUnit === 'micromol'">&micro;mol</template>
                            </td>
                        </tr>
                    </template>
                    <template v-for="(item, index) in formData.formulation.micronutrients.vitamins">
                        <tr v-if="getVitaminValue(item)" :key="'vit_' + index" >
                            <td class="text-left">{{ item.name === 'K' ? 'Vitamin K' : item.name }}</td>
                            <td class="text-right">{{ formatNumber(getVitaminValue(item), 2) }}</td>
                            <td>{{ item.unit }}</td>
                        </tr>
                    </template>
                    <!-- special case - if user select Vitalipid but no vitam K, we need to add Vitamin K from Vitalipid contribution -->
                    <!-- <tr v-if="hasVitalipidButNoVitaminK()">
                        <td class="text-left">Vitamin K</td>
                        <td class="text-right">{{ formatNumber(getVitaminKFromVitalipid(), 2) }}</td>
                        <td>mg</td>
                    </tr> -->
                    <template v-for="(item, index) in formData.formulation.additives">
                        <tr v-if="getAdditiveValue(item.quantity)" :key="'add_' + index" >
                            <td class="text-left">{{ item.label }}</td>
                            <td class="text-right">{{ formatNumber(getAdditiveValue(item.quantity), 2) }}</td>
                            <td>{{ getAdditivesUnit(item) }}</td>
                        </tr>
                    </template>
                </template>
            </table>
            <div class="comments" v-if="showComments && formData.comments">
                <h3>Comments:</h3>
                <p>{{formData.comments}}</p>
            </div>
        </div>
    </div>
</template>

<script>

import tpnUtilsMixin from '@/mixins/tpnUtilsMixin';

export default {
    name: 'RecapTable',
    mixins: [tpnUtilsMixin],
    props: {
        formData: {
            required: true,
        },
        baseInfo: {
            required: true,
        },
        settings: {
            required: true,
        },
        showComments: {
            required: true,
        },
    },
    data() {
        return {
            // volumes: {
            //     total: 0,
            //     lipid: 0,
            //     clear: 0
            // }
        };
    },
    methods: {
        getElectrolitesList() {
            let electrolitesList = [];
            if (this.baseInfo.electrolytes.table_order) {
                this.baseInfo.electrolytes.table_order.forEach((item) => {
                    const selectedItem = this.formData.formulation.electrolytes.find((el) => el.label === item);
                    electrolitesList.push(selectedItem);
                });
            } else {
                electrolitesList = this.formData.formulation.electrolytes;
            }
            return electrolitesList;
        },
        getBagVolumeValue() {
            let value = 0;
            if (this.formData.bag_volume) {
                value = parseFloat(this.formData.bag_volume);
            }
            return value;
        },
        getEnergyValue() {
            let value = 0;
            if (this.formData.bag_volume > 0) {
                if (this.baseInfo.bag_type === 'triple_chamber') {
                    value = this.baseInfo.total_calories;
                } else {
                    // add from amino acid
                    if (this.formData.formulation.macronutrients.amino_acid.quantity) {
                        const selectedItem = this.settings.amino_acid.find((item) => item.label === this.formData.formulation.macronutrients.amino_acid.label);
                        if (selectedItem) {
                            value += (parseFloat(this.formData.formulation.macronutrients.amino_acid.quantity) * selectedItem.calories) / selectedItem.g_l;
                        }
                    }
                    // add from glucose
                    if (this.formData.formulation.macronutrients.glucose.quantity_kcal) {
                        value += parseFloat(this.formData.formulation.macronutrients.glucose.quantity_kcal);
                    }
                    // add from lipids
                    if (this.formData.formulation.macronutrients.lipid.quantity_kcal) {
                        value += parseFloat(this.formData.formulation.macronutrients.lipid.quantity_kcal);
                    }
                }
                // vitamin contributes as well and can be in both types of bags
                this.formData.formulation.micronutrients.vitamins.forEach((item) => {
                    if (item.value) {
                        const selectedItem = this.settings.vitamins.find((el) => el.label === item.name);
                        if (selectedItem && selectedItem.calories) {
                            value += (selectedItem.calories * parseFloat(item.value)) / 1000;
                        }
                    }
                });
            }
            return value;
        },
        getOsmolarityValue() {
            let value = 0;
            if (this.formData.bag_volume > 0) {
                if (this.baseInfo.bag_type === 'triple_chamber') {
                    value = this.baseInfo.osmolarity;
                } else {
                    let volumeTotal = 0;
                    let volumesLipid = 0;
                    let volumesClear = 0;

                    if (this.formData.bag_volume) {
                        volumeTotal = parseFloat(this.formData.bag_volume);
                        volumesLipid = 0;
                        volumesClear = 0;
                        if (this.baseInfo.label === 'Synthamin + Lipid') {
                            let lipidVolume = 0;
                            let vitalipidVolume = 0;
                            // get the lipid
                            if (this.formData.formulation.macronutrients.lipid.quantity_g) {
                                const lipidSettings = this.settings.lipid.find((el) => el.label === this.formData.formulation.macronutrients.lipid.label);
                                if (lipidSettings) {
                                    lipidVolume = (parseFloat(this.formData.formulation.macronutrients.lipid.quantity_g) * 1000) / lipidSettings.g_l;
                                }
                            }

                            // if we have Vitalipid vitamin, add that volume to the total of the lipid chamber
                            const vitalipidForm = this.formData.formulation.micronutrients.vitamins.find((el) => el.name === 'Vitalipid' || el.name === 'Vitalipid Infant');
                            if (vitalipidForm && vitalipidForm.value) {
                                vitalipidVolume = parseFloat(vitalipidForm.value);
                            }

                            volumesLipid = lipidVolume + vitalipidVolume;
                        }
                    }
                    volumesClear = volumeTotal - volumesLipid;

                    // Amino acids
                    if (this.formData.formulation.macronutrients.amino_acid.quantity) {
                        const selectedItem = this.settings.amino_acid.find((item) => item.label === this.formData.formulation.macronutrients.amino_acid.label);
                        if (selectedItem) {
                            const qty = parseFloat(this.formData.formulation.macronutrients.amino_acid.quantity);
                            let osmolarity = (selectedItem.osmolarity / selectedItem.g_l) * qty;
                            if (this.baseInfo.label !== 'Primene') {
                                osmolarity = (osmolarity / volumesClear) * 1000;
                            }
                            value += osmolarity;
                        }
                    }
                    // glucose
                    if (this.formData.formulation.macronutrients.glucose.quantity_g) {
                        const selectedItem = this.settings.glucose.find((item) => item.label === this.formData.formulation.macronutrients.glucose.label);
                        if (selectedItem) {
                            const qty = parseFloat(this.formData.formulation.macronutrients.glucose.quantity_g);
                            let osmolarity = (selectedItem.osmolarity / selectedItem.g_l) * qty;
                            if (this.baseInfo.label !== 'Primene') {
                                osmolarity = (osmolarity / volumesClear) * 1000;
                            }
                            value += osmolarity;
                        }
                    }
                    // lipid
                    if (this.formData.formulation.macronutrients.lipid.quantity_g) {
                        const selectedItem = this.settings.lipid.find((item) => item.label === this.formData.formulation.macronutrients.lipid.label);
                        if (selectedItem) {
                            const qty = parseFloat(this.formData.formulation.macronutrients.lipid.quantity_g);
                            if (volumesLipid) {
                                let osmolarity = (selectedItem.osmolarity / selectedItem.g_l) * qty;
                                if (this.baseInfo.label !== 'Primene') {
                                    osmolarity = (osmolarity / volumesClear) * 1000;
                                }
                                value += osmolarity;
                            }
                        }
                    }
                    // // vitamins
                    this.formData.formulation.micronutrients.vitamins.forEach((el) => {
                        if (el.value) {
                            const selectedItem = this.settings.vitamins.find((item) => item.label === el.name);
                            if (selectedItem && selectedItem.osmolarity) {
                                const qty = parseFloat(el.value);
                                if (el.name === 'Vitalipid' || el.name === 'Vitalipid Infant') {
                                    if (volumesLipid) {
                                        let osmolarity = (selectedItem.osmolarity / 1000) * qty;
                                        if (this.baseInfo.label !== 'Primene') {
                                            osmolarity = (osmolarity / volumesLipid) * 1000;
                                        }
                                        value += osmolarity;
                                    }
                                } else {
                                    let osmolarity = (selectedItem.osmolarity / 1000) * qty;
                                    if (this.baseInfo.label !== 'Primene') {
                                        osmolarity = (osmolarity / volumesClear) * 1000;
                                    }
                                    value += osmolarity;
                                }
                            }
                        }
                    });
                    // electrolytes
                    this.formData.formulation.electrolytes.forEach((el) => {
                        if (el.extra_quantity) {
                            const selectedItem = this.settings.electrolytes.find((item) => item.label === el.label);
                            if (selectedItem) {
                                if (el.label === 'Phosphate') {
                                    const selectedType = selectedItem.type.find((item) => item.label === el.type);
                                    if (selectedType) {
                                        const qty = parseFloat(el.extra_quantity);
                                        let osmolarity = (selectedType.osmolarity / selectedType.mmol_l) * qty;
                                        if (this.baseInfo.label !== 'Primene') {
                                            osmolarity = (osmolarity / volumesClear) * 1000;
                                        }
                                        value += osmolarity;
                                    }
                                } else {
                                    let qty = parseFloat(el.extra_quantity);
                                    // if sodium, add contribution from organic phosphate
                                    if (el.label === 'Sodium') {
                                        const phosphate = this.formData.formulation.electrolytes.find((item) => item.label === 'Phosphate');
                                        if (phosphate && phosphate.extra_quantity) {
                                            if (phosphate.type === 'Organic') {
                                                const phosphateSettings = this.settings.electrolytes.find((item) => item.label === 'Phosphate');
                                                if (phosphateSettings) {
                                                    const selectedType = phosphateSettings.type.find((item) => item.label === 'Organic');
                                                    if (selectedType && selectedType.extra_sodium) {
                                                        qty += (parseFloat(phosphate.extra_quantity) * selectedType.extra_sodium) / selectedType.mmol_l;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    let osmolarity = (selectedItem.osmolarity / selectedItem.mmol_l) * qty;
                                    if (this.baseInfo.label !== 'Primene') {
                                        osmolarity = (osmolarity / volumesClear) * 1000;
                                    }
                                    value += osmolarity;
                                }
                            }
                        }
                    });
                }
            }
            // if (value < 0) {
            //     value = 0;
            // }
            return value;
        },
        getNitrogenValue() {
            let value = 0;
            if (this.baseInfo.bag_type === 'triple_chamber') {
                value = this.baseInfo.default_list_data.nitrogen;
            }

            if (this.baseInfo.bag_type === 'custom') {
                if (this.formData.formulation.macronutrients.amino_acid.quantity) {
                    value = parseFloat(this.formData.formulation.macronutrients.amino_acid.nitrogen);
                }
            }
            return value;
        },
        getAminoAcidValue() {
            let value = 0;
            if (this.baseInfo.bag_type === 'triple_chamber') {
                value = this.baseInfo.default_list_data.amino_acid;
            }

            if (this.baseInfo.bag_type === 'custom') {
               if (this.formData.formulation.macronutrients.amino_acid.quantity) {
                    value = parseFloat(this.formData.formulation.macronutrients.amino_acid.quantity);
                }
            }
            return value;
        },
        getGlucoseValue(unit) {
            let value = 0;
            if (this.baseInfo.bag_type === 'triple_chamber') {
                if (unit === 'kcal') {
                    value = this.baseInfo.default_list_data.glucose_kcal;
                } else {
                    value = this.baseInfo.default_list_data.glucose_g;
                }
            }

            if (this.baseInfo.bag_type === 'custom') {
                if (unit === 'kcal') {
                    if (this.formData.formulation.macronutrients.glucose.quantity_kcal) {
                        value = parseFloat(this.formData.formulation.macronutrients.glucose.quantity_kcal);
                    }
                }
                if (unit === 'g') {
                    if (this.formData.formulation.macronutrients.glucose.quantity_g) {
                        value = parseFloat(this.formData.formulation.macronutrients.glucose.quantity_g);
                    }
                }
            }
            return value;
        },
        getLipidValue(unit) {
            let value = 0;
            if (this.baseInfo.bag_type === 'triple_chamber') {
                if (unit === 'g') {
                    value = this.baseInfo.default_list_data.lipid_g;
                } else {
                    value = this.baseInfo.default_list_data.lipid_kcal;
                }
            }

            if (this.baseInfo.bag_type === 'custom') {
                if (unit === 'kcal') {
                    if (this.formData.formulation.macronutrients.lipid.quantity_kcal) {
                        value = parseFloat(this.formData.formulation.macronutrients.lipid.quantity_kcal);
                    }
                }
                if (unit === 'g') {
                    if (this.formData.formulation.macronutrients.lipid.quantity_g) {
                        value = parseFloat(this.formData.formulation.macronutrients.lipid.quantity_g);
                    }
                }
            }
            // add lipids from vitamins
            // this.formData.formulation.micronutrients.vitamins.forEach((item) => {
            //     if (item.value) {
            //         const vitamin = this.settings.vitamins.find((el) => el.label === item.name);
            //         if (vitamin) {
            //             if (unit === 'g') {
            //                 value += (vitamin.lipid_g_l * item.value) / 1000;
            //             } else {
            //                 value += (vitamin.lipid_kcal_l * item.value) / 1000;
            //             }
            //         }
            //     }
            // });
            return value;
        },
        getElectrolyteValue(item, includeLipids) {
            let value = 0;
            // default electrolytes quantities
            const selectedItem = this.baseInfo.electrolytes.items.find((el) => el.label === item.label);
            if (selectedItem) {
                if (item.label === 'Phosphate') {
                    if (item.type !== '') {
                        const selectedPhosphateType = selectedItem.choices.find((el) => el.label === item.type);
                        if (selectedPhosphateType) {
                            value += selectedPhosphateType.base_quantity;
                            if (!Number.isNaN(parseFloat(item.extra_quantity))) {
                                value += parseFloat(item.extra_quantity);
                            }
                        }
                    }
                    // add extra if we have lipids (only for Synthamin + Lipid base)
                    if (includeLipids && this.baseInfo.macronutrients) {
                        if (this.formData.formulation.macronutrients.lipid.quantity_g) {
                            const selectedLipid = this.settings.lipid.find((el) => el.label === this.formData.formulation.macronutrients.lipid.label);
                            if (selectedLipid) {
                                value += (parseFloat(this.formData.formulation.macronutrients.lipid.quantity_g) * selectedLipid.phosphate) / selectedLipid.g_l;
                            }
                        }
                    }
                } else {
                    value += selectedItem.base_quantity;
                    if (!Number.isNaN(parseFloat(item.extra_quantity))) {
                        value += parseFloat(item.extra_quantity);
                    }
                }
                // add extra if we have amino_acid
                if (this.formData.formulation.macronutrients.amino_acid.quantity) {
                    const selectedAminoAcid = this.settings.amino_acid.find((el) => el.label === this.formData.formulation.macronutrients.amino_acid.label);
                    if (selectedAminoAcid) {
                        // get the right electrolyte
                        // const electrolyteItem = selectedAminoAcid.items.find((el) => el.label === 'Phosphate');
                        const electrolyteItem = selectedAminoAcid.items.find((el) => el.label === item.label);
                        if (electrolyteItem) {
                            value += (parseFloat(this.formData.formulation.macronutrients.amino_acid.quantity) / selectedAminoAcid.g_l) * electrolyteItem.value;
                        }
                    }
                }

                if (item.label === 'Sodium') {
                    // add extra if we have organic phosphate
                    const phosphate = this.formData.formulation.electrolytes.find((el) => el.label === 'Phosphate');
                    if (phosphate && phosphate.extra_quantity) {
                        if (phosphate.type === 'Organic') {
                            const phosphateSettings = this.settings.electrolytes.find((el) => el.label === 'Phosphate');
                            if (phosphateSettings) {
                                const selectedType = phosphateSettings.type.find((el) => el.label === 'Organic');
                                if (selectedType && selectedType.extra_sodium) {
                                    value += (parseFloat(phosphate.extra_quantity) * selectedType.extra_sodium) / selectedType.mmol_l;
                                }
                            }
                        }
                    }

                    // add extra if we have lipids (obly for Synthamin + Lipid base)
                    // NOTE - THIS GOES TO THE LIPID CHAMBER< SO NO NEED TO ADD IT TO CLEAR BAG LIMITS
                    // if (this.baseInfo.macronutrients && this.baseInfo.macronutrients.lipid) {
                    //     if (this.formData.formulation.macronutrients.lipid.quantity_g) {
                    //         const selectedLipid = this.settings.lipid.find((el) => el.label === this.formData.formulation.macronutrients.lipid.label);
                    //         if (selectedLipid) {
                    //             value += (parseFloat(this.formData.formulation.macronutrients.lipid.quantity_g) * selectedLipid.sodium) / selectedLipid.g_l;
                    //         }
                    //     }
                    // }
                    // add extra if we have cernevit vitamin
                    this.formData.formulation.micronutrients.vitamins.forEach((vitamin) => {
                        if (vitamin.name === 'Cernevit' && parseFloat(vitamin.value)) {
                            const selectedVitamin = this.baseInfo.micronutrients.vitamins.find((el) => el.label === vitamin.name);
                            if (selectedVitamin && selectedVitamin.extra) {
                                let country = '';
                                if (this.formData.country === 'Australia') {
                                    country = 'au';
                                }
                                if (this.formData.country === 'New Zealand') {
                                    country = 'nz';
                                }
                                if (country && selectedVitamin.extra[country]) {
                                    const data = selectedVitamin.extra[country];
                                    value += data.sodium_contribution;
                                }
                            }
                        }
                    });
                }
            }

            return value;
        },
        getElectrolyteLabel(item) {
            const selectedItem = this.baseInfo.electrolytes.items.find((el) => el.label === item.label);

            let label = '';

            if (selectedItem) {
                if (item.label === 'Phosphate') {
                    if (this.baseInfo.label === 'Primene' || this.baseInfo.label === 'Synthamin') {
                        label = 'Phosphate (' + item.type + ')';
                    } else {
                        label = 'Phosphate (incl. lipids)';
                    }
                } else {
                    label = item.label;
                }
            }

            return label;
        },
        getTripleChamberBagChlorideValue() {
            let value = this.baseInfo.default_list_data.chloride;
            // add extra from electrolytes
            this.formData.formulation.electrolytes.forEach((item) => {
                if (item.extra_quantity) {
                    const selectedItem = this.settings.electrolytes.find((el) => el.label === item.label);
                    if (selectedItem && selectedItem.chloride_mmol_l > 0) {
                        value += (selectedItem.mmol_l / selectedItem.chloride_mmol_l) * parseFloat(item.extra_quantity);
                    }
                }
            });
            return value;
        },
        getCustomBagChlorideAcetateValue() {
            const value = parseFloat(this.formData.formulation.chloride_acetate.quantity);
            return value;
        },
        getTraceElementValue(value) {
            return value;
        },
        getVitaminValue(item) {
            const val = parseFloat(item.value);

            // // if vitam K add extra K if we also have vitalipid
            // if (item.name === 'K') {
            //     const vitalipid = this.formData.formulation.micronutrients.vitamins.find((el) => el.name === 'Vitalipid' || el.name === 'Vitalipid Infant');

            //     if (vitalipid && vitalipid.value) {
            //         const selectedItem = this.settings.vitamins.find((el) => el.label === vitalipid.name);
            //         if (selectedItem) {
            //             val += (selectedItem.vitamin_k * vitalipid.value) / 1000;
            //         }
            //     }
            // }

            return val;
        },
        hasVitalipidButNoVitaminK() {
            const vitalipid = this.formData.formulation.micronutrients.vitamins.find((el) => el.name === 'Vitalipid' || el.name === 'Vitalipid Infant');
            if (vitalipid && vitalipid.value) {
                const vitaminK = this.formData.formulation.micronutrients.vitamins.find((el) => el.name === 'K');
                if (!vitaminK || !vitaminK.value) {
                    return true;
                }
            }
            return false;
        },
        getVitaminKFromVitalipid() {
            let value = 0;
            const vitalipid = this.formData.formulation.micronutrients.vitamins.find((el) => el.name === 'Vitalipid' || el.name === 'Vitalipid Infant');

            if (vitalipid && vitalipid.value) {
                const selectedItem = this.settings.vitamins.find((el) => el.label === vitalipid.name);
                if (selectedItem) {
                    value = (selectedItem.vitamin_k * vitalipid.value) / 1000;
                }
            }
            return value;
        },
        getAdditiveValue(value) {
            const val = parseFloat(value);
            return val;
        },
        getAdditivesUnit(item) {
            const selectedItem = this.baseInfo.additives.items.find((el) => el.label === item.label);

            let unit = '';

            if (selectedItem) {
                unit = selectedItem.unit;
            }

            return unit;
        },
        zincInTraceElementRecapTotals() {
            return this.formData.traceElementRecapTotals.find((item) => item.name === 'Zinc');
        }
    },
};
</script>
